import { helper } from '@ember/component/helper';

/**
 * Check if an array includes a value
 * Usage: {{array-includes myArray value}}
 */
export default helper(function arrayIncludes([array, value]) {
  if (!Array.isArray(array)) {
    return false;
  }
  return array.includes(value);
});
